import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps, Link } from 'react-router-dom';
import { Globals, Constants, Colors, Print, checkPermission } from 'utils';
import {
  Table,
  Pagination,
  Tooltip,
  Input,
  DatePicker,
  Select,
  Modal,
  User,
} from 'components';
import { SurveysService } from 'services';
import { CleanIcon, StarActiveIcon } from 'assets/icons';
import moment from 'moment';

interface Props extends RootState, RouteComponentProps {
  dispatch: any;
}

const INITIAL_STATE = {
  search: '',
};

class Surveys extends React.Component<Props> {
  timer: any = undefined;

  state = {
    header: ['Abogado', 'Fecha', 'Trámite', 'Calificación', 'N° Orden'],
    form: INITIAL_STATE,
    data: [],
    page: 1,
    last_page: 1,
  };

  componentDidMount() {
    this.props.dispatch({
      type: 'SET_HEADER',
      payload: {
        title: 'Calificaciones',
        onBack: null,
      },
    });

    this.props.dispatch({
      type: 'SET_SUBHEADER',
      payload: {
        title: '',
      },
    });

    this.load();
  }

  load = async (withoutLoading: boolean = false) => {
    const res: any = await SurveysService.get({
      withoutLoading,
      user_id: this.props.user?.id,
      page: this.state.page,
      ...this.state.form,
    });
    this.setState({
      data: res.rows,
      last_page: res.count,
    });
  };

  reset = () => {
    this.setState(
      {
        form: INITIAL_STATE,
        page: 1,
      },
      () => this.load(true),
    );
  };

  change = (e: any, callback = () => {}) => {
    this.setState(
      {
        page: 1,
        form: {
          ...this.state.form,
          [e.target.name]: e.target.value,
        },
      },
      callback,
    );
  };

  render() {
    return (
      <div id="client-surveys">
        <div className="row">
          <div className="col-md-12">
            <div className="row">
              <div className="col-md-3">
                <Input
                  value={this.state.form.search}
                  name="search"
                  label="Buscar"
                  className="input-table"
                  onSubmit={() => this.load()}
                  onChange={(e: any) => {
                    clearTimeout(this.timer);
                    this.timer = setTimeout(() => {
                      this.load(true);
                    }, 1000);
                    this.change(e);
                  }}
                />
              </div>

              <div className="col-md-1">
                {this.state.form != INITIAL_STATE && (
                  <button
                    className="btn btn-clean"
                    onClick={() => this.reset()}
                  >
                    <img src={CleanIcon} />
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>

        <Table
          title="Calificaciones"
          data={this.state.data.length}
          header={this.state.header}
        >
          {this.state.data.map((i: any, index: number) => {
            return (
              <tr key={index}>
                <td>
                  <User image={i.lawyer?.photo} name={i?.lawyer?.full_name} />
                </td>
                <td>{moment(i?.created_at).format('DD-MM-YYYY')}</td>
                <td>{i?.name}</td>
                <td>
                  <div className="container-rating">
                    {Array.from(Array(i?.rating || 0).keys()).map(
                      (item: any, index: number) => {
                        return <img src={StarActiveIcon} key={index} />;
                      },
                    )}
                  </div>
                </td>
                <td className="code">ID {i?.number_format}</td>
              </tr>
            );
          })}
        </Table>

        <Pagination
          pages={this.state.last_page}
          active={this.state.page}
          onChange={async (page: number) => {
            await this.setState({
              page: page,
            });
            this.load();
          }}
        />
      </div>
    );
  }
}

export default connect((state: RootState) => {
  return {
    user: state.user,
  };
})(Surveys);
